<template>
  <el-dialog
    :visible.sync="ccVisible"
    :close-on-click-modal="false"
    :before-close="closeVisible"
    :title="title"
    width="1050px"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      :label-width="labelWidth"
      size="small"
    >
      <el-form-item
          v-if="['close','toTest'].includes(propData.handle)"
          label="出现原因"
          prop="tb_reason"
        >
          <el-input
            v-model="form.tb_reason"
            :autosize="{ minRows: 3, maxRows: 6 }"
            type="textarea"
            clearablep
            placeholder="出现原因"
          />
      </el-form-item>
      <el-form-item
        v-if="['close','toTest'].includes(propData.handle)"
        label="解决方案"
        prop="tb_note"
      >
        <el-input
          v-model="form.tb_note"
          :autosize="{ minRows: 3, maxRows: 6 }"
          type="textarea"
          clearablep
          placeholder="解决方案"
        />
      </el-form-item>
      <el-form-item label="备注" prop="dl_remark">
        <TipTapEditor v-model="form.dl_remark" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" size="small" @click="closeVisible()">取消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="debounce()"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { bugAbandoned, bugClose, bugSubmitTest, bugSubmitAcceptance, bugResolved } from '@/api/defectManagement'
import Tinymce from '@/components/Tinymce'

export default {
  components: { Tinymce },
  props: ['visible', 'propData'],
  data() {
    return {
      form: {
        dl_remark: '',
        tb_note: '',
        tb_reason: ''
      },
      ccVisible: false,
      labelWidth: '150px',
      formRules: {
        tb_note: [{ required: true, message: '请输入', trigger: 'blur' }],
        tb_reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        dl_remark: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      title: ''
    }
  },
  watch: {
    visible: function(val) {
      if (val) {
        switch (this.propData.handle) {
          case 'toTest':
            this.title = '提交测试'
            break
          case 'abandoned':
            this.title = '废弃'
            break
          case 'close':
            this.title = '关闭'
            break
          case 'acceptance':
            this.title = '提交验收'
            break
          case 'resolved':
            this.title = '已解决'
            break

          default:
            break
        }
        if (['close', 'toTest'].includes(this.propData.handle)) {
          this.formRules.dl_remark[0].required = false
        } else {
          this.formRules.dl_remark[0].required = true
        }
      }
      this.ccVisible = val
    }
  },
  methods: {
    // 写个防抖功能
    debounce() {
      let num = 6
      const timer = setInterval(() => {
        this.val = --num
        if (num === 0) {
          clearInterval(timer)
        }
      }, 300)
      this.addSubmit()
    },
    closeVisible() {
      this.$refs.form.resetFields()
      this.$emit('close')
    },
    addSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = {
            tb_id: this.propData.tb_id,
            user_id: this.$store.getters.userId,
            dl_remark: this.form.dl_remark
          }
          let api = ''
          switch (this.propData.handle) {
            case 'toTest':
              api = bugSubmitTest({ ...param, tb_note: this.form.tb_note, tb_reason: this.form.tb_reason })
              break
            case 'abandoned':
              api = bugAbandoned(param)
              break
            case 'close':
              api = bugClose({ ...param, tb_note: this.form.tb_note, tb_reason: this.form.tb_reason })
              break
            case 'acceptance':
              api = bugSubmitAcceptance(param)
              break
            case 'resolved':
              api = bugResolved(param)
              break

            default:
              break
          }

          api.then((response) => {
            if (response.code === '200') {
              this.$message.success('成功！')
              this.$emit('success')
              this.closeVisible()
            }
          })
            .catch((err) => {
              console.log(err)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style>
</style>
